import React, { Component } from 'react'
import "bootstrap/dist/css/bootstrap.css";
import { TableRow, TableCell, Link } from '@aws-amplify/ui-react';
import { downloadfile } from '../../utils/utils';
import { Trash } from 'react-bootstrap-icons';


class EntitySerachReportRow extends Component {

    render() {
        // console.log(this.props.entity);
        return (
            <TableRow>
                <TableCell>
                {this.props.index+1}
                </TableCell>
                <TableCell>
                <Link className='App-link text-center' onClick={() => alert('Sign up for a free account to download your uploaded files!')}>
                        {this.props.entity.file_name}
                    </Link>
                </TableCell>
                <TableCell>
                    {this.props.entity.Type}
                </TableCell>
                <TableCell>
                {this.props.entity.entity}
                </TableCell>
                <TableCell>
                {this.props.entity.page}
                </TableCell>
                <TableCell style={{ textAlign: 'justify'}} dangerouslySetInnerHTML={{__html: this.props.entity.snippet}}>
                </TableCell>
                <TableCell>
                {this.props.entity.Score}
                </TableCell>
                <TableCell>
                        <Link className='App-link text-center' onClick={() => this.props.onDelete(this.props.entity)}>
                            <Trash/>
                        </Link>
                    </TableCell>
            </TableRow>
        )
    }
}
export default EntitySerachReportRow;